import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

/** 6 hours from app load, then clear storage — same for dine-in and takeout. */
const CLEAR_AFTER_MS = 6 * 60 * 60 * 1000;

@Injectable({
  providedIn: 'root',
}) 
export class SessionStorageTimeoutService {
  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor(private router: Router) {}

  /** Starts a one-shot timer; does not reset on mouse, scroll, or other input. */
  start(): void {
    this.timeoutId = setTimeout(() => this.clearAllAndRestart(), CLEAR_AFTER_MS);
  }

  stop(): void {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  private clearAllAndRestart(): void {
    try {
      localStorage.clear();
    } catch {
      /* ignore quota / private mode */
    }
    this.router.navigateByUrl('/').then(() => {
      window.location.reload();
    });
  }
}
